<template>
    <div v-if="interactionSubInstances">
        <div class="mt-2 mb-4">
            <span v-if="!allFilled" v-html="progressText"></span>
        </div>
        <interaction-choice
            :item="item"
            :subInteractions="subInteractions"
            @select="handleSubInteractionSelect"
        />

        <div v-if="allFilled" class="mt-2 mb-4">
            <span v-html="progressText"></span>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { INTERACTION_STATUS } from '@/constants/interaction'
import interactionChoice from '@/components/items/interactionChoiceItem'
import { getLabel } from '@/utils/items'
import { TEXT_TYPES } from '@/constants/i18n';

export default {
    name: 'InteractionChoiceContainer',
    components: {
        'interaction-choice': interactionChoice
    },
    watch: {
        allFilled() {
            if(this.allFilled) {
                this.$emit('ctrlButtonHidden', true)
            }
        }
    },
    props: {
        item: {
            type: Object,
        },
        interactionInstanceToken: {
            type: String
        }
    },
    computed: {
        ...mapGetters([
            'instanceToken',
            'interactionSubInstances'
        ]),
        subInteractions() {
            return this.item.choices.map(choice => {

                const name = this.$t(choice.text);
                const currentSubInstance = this.interactionSubInstances && this.interactionSubInstances.find(subInstance => {
                    return subInstance.name === name
                })
                const selectedSubInstanceFilled = currentSubInstance && (currentSubInstance.status === INTERACTION_STATUS.FILLED || currentSubInstance.status === INTERACTION_STATUS.RESULTS_AVAILABLE)

                const isInstanceOpen = this.interactionSubInstances && this.interactionSubInstances.find(subInstance =>
                    subInstance.status === INTERACTION_STATUS.NEW || subInstance.status === INTERACTION_STATUS.OPENED
                ) && this.interactionSubInstances.find(subInstance =>
                    subInstance.status === INTERACTION_STATUS.NEW || subInstance.status === INTERACTION_STATUS.OPENED
                ).name !== name

                return {
                    disabled: isInstanceOpen || selectedSubInstanceFilled,
                    filled: selectedSubInstanceFilled,
                    ...currentSubInstance,
                    ...choice,
                }
            })
        },
        isOneOpen() {
            return this.subInteractions.some(item => item.status === INTERACTION_STATUS.OPENED);
        },
        numberCompleted() {
            return this.subInteractions.filter(item => item.status === INTERACTION_STATUS.FILLED).length;
        },
        allFilled() {
            const foundNotFilled = this.subInteractions.some(subInstance => !subInstance.filled)
            return !foundNotFilled
        },
        progressText() {
            if(this.isOneOpen) {
                return this.$t(getLabel(this.item, 'IN_PROGRESS').text)
            }
            return this.$t(getLabel(this.item, `${this.numberCompleted}_COMPLETED`).text)
        }
    },
    methods: {
        ...mapActions([
            'fetchSubInstances',
            'startSubInstance',
            'continueSubInstance',
            'fetchInteractionInstance',
            'fetchInstanceItems',
            'fetchTranslations'
        ]),
        async handleSubInteractionSelect(subInteraction) {
            const name = this.$t(subInteraction.text);
            const subInstance = this.interactionSubInstances && this.interactionSubInstances.find(subInstance => subInstance.name === name)

            if (!subInstance) {
                const name = this.$t(subInteraction.text);
                const itemId = this.item.itemId
                const interactionInstanceToken = this.interactionInstanceToken

                await this.startSubInstance({ interactionInstanceToken, itemId, name });
                if(this.instanceToken) {
                    await this.fetchInteractionInstance({ interactionInstanceToken: this.instanceToken })
                    await this.fetchInstanceItems({ interactionInstanceToken: this.instanceToken })
                    await this.fetchTranslations({ textType: TEXT_TYPES.ITEM, interactionToken: this.instanceToken })
                    await this.fetchTranslations({ textType: TEXT_TYPES.CHOICE, interactionToken: this.instanceToken })
                }

            } else if (subInstance.status === INTERACTION_STATUS.NEW || subInstance.status === INTERACTION_STATUS.OPENED) {
                await this.fetchInteractionInstance({ interactionInstanceToken: subInstance.token })
                await this.fetchInstanceItems({ interactionInstanceToken: subInstance.token })
                await this.fetchTranslations({ textType: TEXT_TYPES.ITEM, interactionToken: subInstance.token })
                await this.fetchTranslations({ textType: TEXT_TYPES.CHOICE, interactionToken: subInstance.token })
            }
        }
    },
    async mounted() {
        await this.fetchSubInstances({
            interactionInstanceToken: this.interactionInstanceToken,
            itemId: this.item.itemId
        })

        this.$emit('ctrlButtonHidden', true)

        if(this.allFilled) {
            this.$emit('ctrlButtonHidden', false)
            this.$emit('answer', { result: 1 })
        }
    }
}
</script>
